.container {
  width: 100%;
  position: relative;
  aspect-ratio: 16 / 9;

  [data-card-actions] {
    background: transparent;
    border: none;
    & div {
      svg {
        fill: var(--color-grey-4);
        height: 1.6rem;
        background-color: transparent;
      }
    }

    [data-select-text] {
      padding-left: 0.8rem;
      background-color: var(--color-grey-8);
      color: var(--color-grey-2);
    }

    [data-option-menu] {
      background-color: var(--color-grey-8);
      color: var(--color-grey-2);
    }
  }
}
